// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"x_J","noSpacing":"x_K"};